// const server = "http://localhost";
// const domain = "localhost";
// const port = 9068;
const server = "https://apisays.mansolutions.app";
const port = 443;
const domain = "admin.saysgroup.com";
export { server, port, domain };
